export default __webpack_public_path__ + "static/ogp-osandojo-11f2fd1b55f5abfac79b819c41c113df.jpg";